import React from 'react'
import { useTranslation } from 'react-i18next'

import { SocialProvider } from '../../../services/keycloakAuth'
import SocialButton from './SocialButton'

import styles from './SocialButtonsSection.module.scss'

interface SocialButtonsSectionProps {
    onSocialLogin: (provider: SocialProvider) => void
    disabled?: boolean
    dividerText?: string
    headerText?: string
    dividerPosition?: 'top' | 'bottom'
    providers?: SocialProvider[]
}

const PROVIDER_LABELS: Record<SocialProvider, string> = {
    apple: 'Apple',
    facebook: 'Facebook',
    google: 'Google',
}

const SocialButtonsSection: React.FC<SocialButtonsSectionProps> = ({
    onSocialLogin,
    disabled = false,
    dividerText,
    headerText,
    dividerPosition = 'top',
    providers = ['apple', 'facebook', 'google'],
}) => {
    const { t } = useTranslation()
    const resolvedDividerText = dividerText || t('common:orContinueWith')

    const divider = (
        <div className={styles.socialDivider}>
            <span className={styles.socialDividerLine} />
            <span className={styles.socialDividerText}>{resolvedDividerText}</span>
            <span className={styles.socialDividerLine} />
        </div>
    )

    return (
        <div className={styles.socialSection}>
            {dividerPosition === 'top' && divider}
            {headerText && <p className={styles.socialSectionHeader}>{headerText}</p>}
            <div className={styles.socialButtons}>
                {providers.map((provider) => (
                    <SocialButton
                        key={provider}
                        provider={provider}
                        label={PROVIDER_LABELS[provider]}
                        onClick={() => onSocialLogin(provider)}
                        disabled={disabled}
                    />
                ))}
            </div>
            {dividerPosition === 'bottom' && divider}
        </div>
    )
}

export default SocialButtonsSection
